import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { hMacAjax } from 'grt-tool-lib-front';

import { baseURL } from '@/httpService/API';
let improveOrgList = `${baseURL}/grt-student-service/open/student/v1/student-invite/org/list`;
// data_source_type 1自定义  2平台数据源
const SelectForm = (props) => {
    let { setting = {}, updated, desc } = props;

    const disabled = updated !== 0,
        [options, setOptions] = useState([]);

    // todo 请求后端数据源接口
    let getOptions = () => {
        // setTimeout(() => {
        //     setOptions([{ id: 1, name: '平台数据源' }]);
        // }, 500);

        hMacAjax.get(improveOrgList).then((res) => {
            if (res.success) {
                let items = [];
                for (let i = 0; i < res.data?.length; i++) {
                    let item = {
                        id: res.data[i]['id'],
                        name: res.data[i]['org_name']
                    };
                    items.push(item);
                }
                setOptions(items);
            }
        });
    };
    useEffect(() => {
        if (setting.data_source_type === 1) {
            let enabledOption = setting.options.filter((ele) => ele.enabled === true);

            setOptions(enabledOption);
        } else {
            getOptions();
        }
    }, []);

    return (
        <Select
            optionFilterProp={'name'}
            mode={setting.type === 'multiple' ? 'multiple' : ''}
            disabled={disabled}
            fieldNames={{ label: 'name', value: 'id' }}
            placeholder={desc}
            options={options}
            showSearch={true}
        />
    );
};
export default SelectForm;
